import React, { useRef } from 'react';
import { Platform, View } from 'react-native';
import LinearGradient from 'utils/packages/linearGradient';
import Animated, { Extrapolate, interpolate, interpolateColor, useAnimatedStyle, } from 'react-native-reanimated';
import { rem, SearchBar } from 'design-system';
import useColors from 'hooks/useColors';
import useColorScheme from 'hooks/useColorScheme';
import useHeaderHeight from 'hooks/useHeaderHeight';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { isWeb } from '../../constants';
const AnimatedSearchComponent = ({ scrollY, headerInfoHeight, scrollToSearchBar, onChangeSearchTerm, }) => {
    const styles = useStyles(styleSet);
    const colors = useColors();
    const headerHeight = useHeaderHeight();
    const colorScheme = useColorScheme();
    const refSearchBar = useRef(null);
    const headerBackground = useAnimatedStyle(() => ({
        transform: [
            {
                translateY: interpolate(scrollY.value, [0, headerInfoHeight, headerInfoHeight + 1], [headerInfoHeight, 0, 0]),
            },
        ],
    }), []);
    const animatedMargins = useAnimatedStyle(() => ({
        shadowOpacity: colorScheme === 'dark'
            ? 0
            : interpolate(scrollY.value, [headerInfoHeight - 20, headerInfoHeight], [0, 1]),
        backgroundColor: interpolateColor(scrollY.value, [headerInfoHeight - 20, headerInfoHeight], [colors.background.dark, colors.cards.onDark]),
    }), [colors, colorScheme]);
    const androidShadowOpacity = useAnimatedStyle(() => ({
        opacity: interpolate(scrollY.value, [headerInfoHeight - 20, headerInfoHeight], [0, 1], Extrapolate.CLAMP),
    }));
    const textInputStyle = useAnimatedStyle(() => ({
        backgroundColor: interpolateColor(scrollY.value, [headerInfoHeight - 20, headerInfoHeight], [colors.cards.onDark, colors.background.dark]),
    }), [colors]);
    const { paddingHorizontalStyle } = useAppFrameDimensions(isWeb);
    return (<Animated.View style={[styles.background, headerBackground, { marginTop: headerHeight }]}>
      <Animated.View style={[styles.container, paddingHorizontalStyle, animatedMargins]}>
        <View style={styles.flex}>
          <SearchBar forSearchHeader ref={refSearchBar} onFocus={scrollToSearchBar} textInputBgStyles={textInputStyle} onChangeSearchTerm={onChangeSearchTerm}/>
        </View>
      </Animated.View>
      {Platform.OS === 'android' && (<Animated.View style={androidShadowOpacity}>
          <LinearGradient pointerEvents="none" style={[styles.androidShadow]} colors={[
                colors.shadows.androidShadowGradientStart,
                colors.shadows.androidShadowGradientEnd,
            ]}/>
        </Animated.View>)}
    </Animated.View>);
};
const styleSet = createStyleSheets((colors) => ({
    background: {
        position: 'absolute',
        left: 0,
        right: 0,
        zIndex: 1,
    },
    androidShadow: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        height: 10,
    },
    row: {
        alignItems: 'center',
        flexDirection: 'row',
    },
    flex: {
        flex: 1,
    },
    container: {
        ...colors.shadows.extendedHeader,
    },
    fakeSearchBar: {
        marginBottom: rem(16),
    },
}));
export default AnimatedSearchComponent;
